export enum OrderStop {
	CakoviceB2c = "CakoviceB2c",
	CakoviceB2b = "CakoviceB2b",
	CentralB2c = "CentralB2c",
	CentralB2b = "CentralB2b",
	PetrinyB2c = "PetrinyB2c",
	PetrinyB2b = "PetrinyB2b",
	DeliveryB2b = "DeliveryB2b",
}

export enum AllOptions {
	AllOptions = "AllOptions",
	AllBranches = "AllBranches",
}

export const orderStopWithAll = [...Object.values(AllOptions), ...Object.values(OrderStop)];

export const orderStopNameMap: Record<OrderStop, string> = {
	[OrderStop.CakoviceB2c]: "Odstavit B2C výdej na Čakovicích",
	[OrderStop.CakoviceB2b]: "Odstavit B2B výdej na Čakovicích",
	[OrderStop.CentralB2c]: "Odstavit B2C výdej na centrále",
	[OrderStop.CentralB2b]: "Odstavit B2B výdej na centrále",
	[OrderStop.PetrinyB2c]: "Odstavit B2C výdej na Petřinách",
	[OrderStop.PetrinyB2b]: "Odstavit B2B výdej na Petřinách",
	[OrderStop.DeliveryB2b]: "Odstavit B2B rozvoz na adresu",
};

export const shortOrderStopNameMap: Record<OrderStop, string> = {
	[OrderStop.CakoviceB2c]: "Čakovice – B2C",
	[OrderStop.CakoviceB2b]: "Čakovice – B2B",
	[OrderStop.CentralB2c]: "Centrála – B2C",
	[OrderStop.CentralB2b]: "Centrála – B2B",
	[OrderStop.PetrinyB2c]: "Petřiny – B2C",
	[OrderStop.PetrinyB2b]: "Petřiny – B2B",
	[OrderStop.DeliveryB2b]: "Rozvoz – B2B",
};

export const orderStopNameMapWithAll = {
	[AllOptions.AllOptions]: "Všechny možnosti",
	[AllOptions.AllBranches]: "Všechny pobočky",
	...orderStopNameMap,
};
